var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","fixed":"","dark":"","color":"light-blue darken-3"}},[_c('span',[_vm._v(_vm._s(_vm.credit))]),_c('v-spacer'),_c('span',[_vm._v("ver "+_vm._s(_vm.ver))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }